
let ApiAccessHash1 = "";

const ApiAccessHash= ()=>{
  if(ApiAccessHash1===''){
 return fetch('/GetData1')
  .then(response => response.json())
  .then(data =>{
    ApiAccessHash1=data;
    return data
  });}
  else return ApiAccessHash1;
}

export default ApiAccessHash;